import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';

@Component({
  selector: 'app-roommanager',
  templateUrl: './roommanager.component.html',
  styleUrls: ['./roommanager.component.scss'],
})
export class RoommanagerComponent implements OnInit {
    @Input() title: any;
    @Input() image: any;
    @Input() text: any;
    @Input() reservation: any;
    @Input() buttons: any;
    @Input() small: any;
    home3 = true;
    rommmanager_dontforget = false;
    roommanager_share = false;
    roommanager_sent = false;
    roommanager_addguest = false;
    roommanager_guestadded = false;
    checkoutpage_invoice = false;
    lateCheckout = false;
    checkoutpage_thankyou = false;
  public environment = environment;
  roomManager = true;
  constructor(private router: Router) { }

  ngOnInit() {}

  goBack(){
    window.history.back();
  }

  goQrcode(){
    this.router.navigate(["/tabs/qrcode"]);
  }
}
